import { useApolloClient, useMutation, useQuery } from "@apollo/client";
import { Alert, MenuItem, Stack, TextField, Typography } from "@mui/material";
import { useState } from "react";
import { worksheetFieldSx } from "./worksheetStyles";
import { draftColors } from "modules/proposals/draft/draftDesignTokens";
import { PROPOSAL, SETTINGS, SWITCH } from "./api";
export default function ProposalMethod({ id, readOnly }: { id: string; readOnly: boolean }) {
  const client = useApolloClient();
  const { data } = useQuery(PROPOSAL, { variables: { id } });
  const { data: settings } = useQuery(SETTINGS);
  const [change, { loading }] = useMutation(SWITCH);
  const [error, setError] = useState("");
  const proposal = data?.worksheetProposal;
  if (
    !proposal ||
    (!settings?.worksheetSettings.enabled && proposal.estimatingMethod !== "worksheet")
  )
    return null;
  const populated = proposal.stages.some((s: any) => s.proposalProducts.length > 0);
  return (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      spacing={1.5}
      alignItems={{ xs: "stretch", sm: "center" }}
      sx={{ px: 1, py: 1.5, ...worksheetFieldSx }}
    >
      <TextField
        sx={{ width: { xs: "100%", sm: 220 }, flexShrink: 0 }}
        select
        size="small"
        label="Estimating method"
        value={proposal.estimatingMethod}
        disabled={readOnly || populated || loading || !settings?.worksheetSettings.enabled}
        onChange={async (e) => {
          setError("");
          try {
            await change({ variables: { id, method: e.target.value } });
            await client.refetchQueries({ include: [PROPOSAL, "customGetProposal"] });
          } catch (err) {
            setError((err as Error).message);
          }
        }}
      >
        <MenuItem value="worksheet">Worksheet</MenuItem>
        <MenuItem value="production">Production-based</MenuItem>
      </TextField>
      {populated && (
        <Typography sx={{ fontSize: 12, color: draftColors.textSecondary }}>
          This proposal contains line items. Its estimating method is locked.
        </Typography>
      )}
      {error && <Alert severity="error">{error}</Alert>}
    </Stack>
  );
}
